window.vendors = window.vendors = {};
